import { render } from "./ElementsListing.vue?vue&type=template&id=0059c98d&scoped=true"
import script from "./ElementsListing.vue?vue&type=script&lang=js"
export * from "./ElementsListing.vue?vue&type=script&lang=js"

import "./ElementsListing.vue?vue&type=style&index=0&id=0059c98d&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0059c98d"]])

export default __exports__